import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { API_BASE_URL } from './config/api';
import './index.css';
import reportWebVitals from './reportWebVitals';

// 프로덕션 환경에서 콘솔 로그 비활성화 (보안을 위해)
if (process.env.NODE_ENV === 'production') {
  // 모든 console 메서드를 빈 함수로 오버라이드
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.debug = () => {};
  console.trace = () => {};
  console.table = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
  console.groupCollapsed = () => {};
  // console.error는 중요한 에러이므로 유지하되, 민감한 정보는 제거
  const originalError = console.error;
  console.error = (...args: any[]) => {
    // 프로덕션에서는 에러만 간단히 로깅 (스택 트레이스 제거)
    if (args.length > 0 && typeof args[0] === 'string') {
      originalError(args[0]);
    }
  };
}

// 클라이언트 에러 모니터링: 전역 에러 핸들러
const sendErrorToServer = async (errorInfo: {
  message: string;
  source?: string;
  lineno?: string;
  colno?: string;
  stack?: string;
  userAgent?: string;
  url?: string;
  context?: Record<string, any>;
}) => {
  try {
    await fetch(`${API_BASE_URL}/api/error-report/client`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(errorInfo),
    });
  } catch (err) {
    // 에러 전송 실패해도 무시 (무한 루프 방지)
    console.error('에러 리포트 전송 실패:', err);
  }
};

// 전역 에러 핸들러
window.onerror = (
  message: string | Event,
  source?: string,
  lineno?: number,
  colno?: number,
  error?: Error,
) => {
  const errorMessage =
    typeof message === 'string' ? message : message.toString();
  const errorStack = error?.stack || '';

  sendErrorToServer({
    message: errorMessage,
    source,
    lineno: lineno?.toString(),
    colno: colno?.toString(),
    stack: errorStack,
    userAgent: navigator.userAgent,
    url: window.location.href,
  });

  // 기본 에러 처리도 유지
  return false;
};

// Promise rejection 핸들러
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const errorMessage =
    reason?.message ||
    (typeof reason === 'string' ? reason : 'Unhandled Promise Rejection');
  const errorStack = reason?.stack || '';

  sendErrorToServer({
    message: errorMessage,
    stack: errorStack,
    userAgent: navigator.userAgent,
    url: window.location.href,
    context: {
      type: 'unhandledrejection',
      reason: typeof reason === 'object' ? JSON.stringify(reason) : reason,
    },
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
